module.exports = __webpack_public_path__ + "img/share.408d7d06.svg";